import { useState, useEffect, useCallback } from 'react';
import './style.css';
import { Link } from 'react-router-dom';
import { OrdersService } from 'src/services/Orders';

import DataTable from 'react-data-table-component';
import {
  dataTableSortFunction,
  filterPedidos,
  capitalizeFirstLetter,
  formatPrice,
} from 'src/services/utils';
import { useUserContext } from 'src/contexts/UserContext';
import ButtonPedidos from 'src/components/ButtonPedidos';
import { PageLayout } from 'src/components/PageLayout';
import styles from './styles.module.scss';
import clsx from 'clsx';
import { Tooltip } from '@material-ui/core';

const customStyles = {
  header: {
    style: {
      minHeight: '56px',
      fontWeight: 'bolder',
      color: '#000',
    },
  },
  headRow: {
    style: {},
  },
  headCells: {
    style: {
      fontSize: '14px',
    },
  },
  cells: {
    style: {},
  },
};

function formatColor(type) {
  let cor = type.toString();
  if (cor === 'Confirmada' || cor === 'Confirmado') {
    cor = 'confirmado-card';
  } else if (cor === 'A confirmar') {
    cor = 'wait-card';
  } else if (cor === 'Rejeitada') {
    cor = 'reject-card';
  } else if (cor === 'Solicitar Revisão') {
    return 'reject-card';
  } else {
    cor = 'null-card';
  }

  return cor;
}

const pageOptions = {
  rowsPerPageText: 'Linhas Por Página',
  rangeSeparatorText: 'de',
  selectAllRowsItem: true,
  selectAllRowsItemText: 'Todos',
};

export function Orders() {
  const [filteredOrders, setFilteredOrders] = useState();

  const [pedidos, setPedidos] = useState();

  const { sendEvent, showToast } = useUserContext();

  const [fields, setFields] = useState({
    search: '',
    status: '',
    from: '',
    to: '',
  });

  const columns = [
    {
      name: (
        <Tooltip
          placement="top"
          title="Código Interno da inventa para o seu pedido"
        >
          <td>Nº do pedido</td>
        </Tooltip>
      ),
      selector: item => item?.Lojista_Order?.name || '-',
      sortable: true,
      key: 'id',

      fontWeight: 'bold',
    },
    {
      name: (
        <Tooltip placement="top" title="Nome do cliente">
          <td>Cliente</td>
        </Tooltip>
      ),
      selector: item =>
        item.Lojista?.name ? capitalizeFirstLetter(item.Lojista?.name) : '-',
      sortable: true,
      fontWeight: 'bold',
      center: true,
      key: 'cliente',
    },
    {
      name: (
        <Tooltip title="Data de realização do pedido">
          <td>Data do pedido</td>
        </Tooltip>
      ),

      selector: e => {
        const data = e.Order_Date || e.created_at;

        let dataFormatada = '-';

        if (data) {
          const dateObj = new Date(data);
          const month = dateObj.getMonth() + 1;
          const day = dateObj.getDate();
          const year = dateObj.getFullYear();
          const dayFormatted = day < 10 ? `0${day}` : day;
          const monthFormatted = month < 10 ? `0${month}` : month;
          dataFormatada = `${dayFormatted}/${monthFormatted}/${year}`;
        }

        return dataFormatada;
      },
      sortable: true,
      key: 'order_date',
      grow: 1,
      center: true,
      fontWeight: 'bold',
    },
    {
      name: (
        <Tooltip title="Valor de repasse para o fornecedor">
          <td style={{ fontSize: '13.8' }}>Valor de repasse</td>
        </Tooltip>
      ),
      selector: e => {
        const price = e.Total ? formatPrice(e.Total) : 'N/A';
        return price || 'N/A';
      },
      sortable: true,
      fontWeight: 'bold',
      key: 'value',
      center: true,
    },
    {
      name: (
        <Tooltip title="Situação atual da documentação dos pedidos e sinalização dos faltantes">
          <td style={{ fontSize: '13.8' }}>
            <div>Documentos Enviados</div>
          </td>
        </Tooltip>
      ),

      // Comprovante de envio: "CTe_FP"
      // Informações de rastreio: "Tracking_Number" e "Transportadora"
      // Custo de envio: "Shipping_Cost"
      // Data de postagem: "Data_e_hora_de_Envio"
      // NF em PDF: "Danfe_FP"
      // NF em XML: "NF_FP"
      // ICMS-ST: "ICMS_ST"

      cell: row => (
        <td className="py-2">
          <div>
            {row.NF_FP || row.NF_ERP ? (
              <i className="fas fa-check green-icon" />
            ) : (
              <i className="fas fa-times red-icon" />
            )}{' '}
            XML da Nota Fiscal
          </div>
          <div>
            {row.Danfe_FP || row.Danfe_ERP ? (
              <i className="fas fa-check green-icon" />
            ) : (
              <i className="fas fa-times red-icon" />
            )}{' '}
            PDF da Nota Fiscal
          </div>
          <div>
            {row.CTe_FP ? (
              <i className="fas fa-check green-icon" />
            ) : (
              <i className="fas fa-times red-icon" />
            )}{' '}
            Comprovante de Envio
          </div>
          <div>
            {row.Transportadora ? (
              <i className="fas fa-check green-icon" />
            ) : (
              <i className="fas fa-times red-icon" />
            )}{' '}
            Transportadora
          </div>
          <div>
            {row.Tracking_Number ? (
              <i className="fas fa-check green-icon" />
            ) : (
              <i className="fas fa-times red-icon" />
            )}{' '}
            Link / Código de rastreio
          </div>
          <div>
            {row.Shipping_Cost ? (
              <i className="fas fa-check green-icon" />
            ) : (
              <i className="fas fa-times red-icon" />
            )}{' '}
            Custo de envio
          </div>
          <div>
            {row.Data_e_hora_de_Envio ? (
              <i className="fas fa-check green-icon" />
            ) : (
              <i className="fas fa-times red-icon" />
            )}{' '}
            Data de postagem
          </div>
          <div>
            {row.Comprovante_de_Entrega_FP ? (
              <i className="fas fa-check green-icon" />
            ) : (
              <i className="fas fa-times red-icon" />
            )}{' '}
            Comprovante de Entrega
          </div>
          <div>
            {row.ICMS_ST ? (
              <i className="fas fa-check green-icon" />
            ) : (
              <i className="fas fa-times red-icon" />
            )}{' '}
            ICMS-ST
          </div>
        </td>
      ),
      grow: 2,
      center: 'true',
      style: () => ({
        maxHeight: 'none',
      }),
    },
    {
      name: (
        <Tooltip title="Situação atual do pedido">
          <td style={{ fontSize: '13.8' }}>Status</td>
        </Tooltip>
      ),
      center: 'true',
      selector: e =>
        e.Status_Fornecedores_Portal ? e.Status_Fornecedores_Portal : '-',
      cell: row => (
        <td
          className={
            row.Status_Fornecedores_Portal
              ? formatColor(row.Status_Fornecedores_Portal)
              : '-'
          }
        >
          <span className="px-2 text-nowrap">
            {row.Status_Fornecedores_Portal
              ? row.Status_Fornecedores_Portal === 'Rejeitada'
                ? 'Revisão solicitada'
                : row.Status_Fornecedores_Portal
              : '-'}
          </span>
        </td>
      ),
      fontWeight: 'bold',
      key: 'status',
    },
    {
      cell: row => (
        <td>
          <Link
            to={{
              pathname: `/pedido/details-v2/${row.order_id}`,
            }}
            onClick={() => sendEvent('order-detail', { orderId: row.order_id })}
            className="change-link"
          >
            <div className="change-link">
              {!row.Status_Fornecedores_Portal ? (
                <ButtonPedidos type="Revisar" />
              ) : (
                <ButtonPedidos type="Detalhes" />
              )}
            </div>
          </Link>
        </td>
      ),
      right: true,
    },
  ];

  const sortOrders = data =>
    data.sort((b, a) => {
      const aDate = new Date(a.Order_Date || a.created_at);
      const bDate = new Date(b.Order_Date || b.created_at);
      return aDate.getTime() - bDate.getTime();
    });

  const transformOrderStatus = useCallback(status => {
    const statusObject = {
      WAITING_SALES_ORDER_VALIDATION: 'Em Validação',
      TO_BE_CONFIRMED: 'A confirmar',
      CONFIRMED: 'Confirmada',
      INVOICE_RECEIVED: 'Confirmada',
      SHIPPED: 'Enviada',
      SHIPPING_CONFIRMED: 'Enviada',
      UNDER_REVIEW: 'Revisão Solicitada',
      CANCELLED: 'Rejeitada',
      DELIVERED: 'Entregue',
    };

    return statusObject[status] || status;
  }, []);

  const getNewOrders = useCallback(async () => {
    const response = await OrdersService.getNewOrders();
    const { orders } = response.data;

    return orders.map(order => ({
      order_id: order.uuid,
      Lojista_Order: { name: order.number },
      Lojista: {
        name: order.customer === '' ? '-' : order.customer,
      },
      Order_Date: order.creationDate,
      cnpj: order.customerRegistrationNumber,
      Total: order.netValue,
      Danfe_FP: order.documents.invoicePDF,
      NF_FP: order.documents.invoiceXML,
      CTe_FP: order.documents.CTE,
      Transportadora: order.documents.shippingCompany,
      Tracking_Number: order.documents.trackingCode,
      Shipping_Cost: order.documents.finalShippingCost,
      Data_e_hora_de_Envio: order.documents.shippingDate,
      Comprovante_de_Entrega_FP: order.documents.deliveryReceipt,
      ICMS_ST: order.documents.ICMSST,
      Status_Fornecedores_Portal: transformOrderStatus(order.status),
      Source: 'New',
    }));
  }, []);

  const getOldOrders = useCallback(async () => {
    const response = await OrdersService.getOrders();
    const { data } = response;

    return data;
  }, []);

  const getOrders = useCallback(async () => {
    const promises = [getNewOrders(), getOldOrders()].map(async promise => {
      try {
        const response = await promise;
        return response;
      } catch (error) {
        showToast('Não foi possível carregar todos seus pedidos', 'error');
        return [];
      }
    });

    const [newOrdersResponse, oldOrdersResponse] = await Promise.all(promises);

    const data = [...newOrdersResponse, ...oldOrdersResponse];

    if (data) {
      const orders = sortOrders(data);

      setPedidos(orders);
    } else {
      setPedidos([]);
    }
  }, []);

  useEffect(() => {
    getOrders();
  }, [getOrders]);

  useEffect(() => {
    if (pedidos) {
      const orders = filterPedidos(pedidos, fields);
      setFilteredOrders(orders);
    }
  }, [fields, pedidos]);

  return (
    <PageLayout>
      <div
        className={clsx('p-md-3 p-2', styles.contentRoot)}
        id="orders-wrappers"
      >
        <div>
          <h1 className="title-section display-5 mb-4 fw-light">Pedidos</h1>
        </div>

        <div className="row d-flex align-items-center justify-content-center flex-wrap w-100 mb-4 mt-2 mx-0">
          <div className="col-12 col-md-2 col-lg-auto mb-2 mb-md-0">
            <button
              className="float-start btn border border-2 border-dark fw-bold d m-0"
              onClick={() =>
                setFields({
                  search: '',
                  status: '',
                  from: '',
                  to: '',
                })
              }
            >
              Limpar
            </button>
          </div>
          <div className="col-12  col-md-3 mb-2 mb-md-0">
            <div className="search-bar px-3">
              <input
                type="text"
                name="search"
                className="py-4"
                id="search"
                placeholder="Buscar por nº, valor sem impostos, cliente"
                value={fields.search}
                onChange={e => {
                  setFields({ ...fields, [e.target.name]: e.target.value });
                }}
              />
              <i className="fas fa-search" />
            </div>
          </div>
          <div className="col-12 col-md-2 mb-2 mb-md-0">
            <select
              name="status"
              style={{ color: '#666666', borderColor: '#e5e5e5' }}
              className="form-select input-codigo-ras"
              aria-label="Transportadora select"
              value={fields.status}
              onChange={e => {
                setFields({ ...fields, [e.target.name]: e.target.value });
              }}
            >
              <option defaultValue value="">
                Todos os Status
              </option>
              <optgroup label="Status da ordem">
                <option value="SO:A confirmar">A confirmar</option>
                <option value="SO:Confirmada">Confirmada</option>

                <option value="SO:Entregue">Entregue</option>
                <option value="SO:Enviada">Enviada</option>
                <option value="SO:Rejeitada">Revisão solicitada</option>
              </optgroup>
              {/* <optgroup label="Status do repasse">
                  <option value="SR:Pendente">Pendente</option>
                  <option value="SR:Realizada">Realizada</option>
                  <option value="SR:Rejeitada">Rejeitada</option>
                </optgroup> */}
            </select>
          </div>
          <div className="col-12 col-md-5 d-flex align-items-center flex-column flex-md-row">
            <input
              type="date"
              className={clsx('input-date flex-grow-1', styles.dateInput)}
              name="from"
              value={fields.from}
              max={fields.to}
              onChange={e => {
                setFields({ ...fields, [e.target.name]: e.target.value });
              }}
            />
            <p className="text-muted mb-0 p-2 text-center">até</p>
            <input
              type="date"
              className={clsx('input-date flex-grow-1', styles.dateInput)}
              name="to"
              value={fields.to}
              min={fields.from}
              onChange={e => {
                setFields({ ...fields, [e.target.name]: e.target.value });
              }}
            />
          </div>
        </div>

        <DataTable
          columns={columns}
          data={filteredOrders || []}
          onSort={(column, sortDirection) => {
            const newDataFiltered = [
              ...dataTableSortFunction(
                filteredOrders || [],
                column,
                sortDirection,
              ),
            ];
            setFilteredOrders(newDataFiltered);
          }}
          sortServer
          pagination
          noDataComponent={
            filteredOrders ? (
              'Sem resultados...'
            ) : (
              <div className="spinner-border m-5" role="status" />
            )
          }
          persistTableHead
          highlightOnHover="true"
          responsive="true"
          customStyles={customStyles}
          paginationComponentOptions={pageOptions}
          fixedHeader
          fixedHeaderScrollHeight="1000vh"
        />
      </div>
    </PageLayout>
  );
}
